import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cypherReportIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 18,
  },
  height: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "!tw-w-[19px] !tw-h-[19px]"
  }, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.82097 0.785227C4.82097 0.351558 5.21181 0 5.69394 0H9.6462C10.1283 0 10.5192 0.351558 10.5192 0.785227V1.59929C10.5192 2.03296 10.1283 2.38452 9.6462 2.38452H5.69394C5.21181 2.38452 4.82097 2.03296 4.82097 1.59929V0.785227ZM2.73398 1.19222H3.82097V1.59929C3.82097 2.68225 4.76181 3.38452 5.69394 3.38452H9.6462C10.5783 3.38452 11.5192 2.68225 11.5192 1.59929V1.19222H12.6058C12.9331 1.19222 13.2469 1.32223 13.4784 1.55365C13.7098 1.78506 13.8398 2.09893 13.8398 2.4262V7.81833H11.2305C10.7346 7.81833 10.259 8.01533 9.90833 8.366C9.55767 8.71667 9.36067 9.19227 9.36067 9.68813V11.4269C9.35853 12.6669 9.7796 13.8707 10.5543 14.839C10.919 15.2949 11.3518 15.6858 11.834 16H2.73398C2.40671 16 2.09284 15.87 1.86142 15.6385C1.63001 15.4071 1.5 15.0933 1.5 14.766V2.4262C1.5 2.09893 1.63001 1.78506 1.86142 1.55365C2.09284 1.32223 2.40671 1.19222 2.73398 1.19222ZM4.46688 5.67318C4.19073 5.67318 3.96688 5.89703 3.96688 6.17318C3.96688 6.44932 4.19073 6.6732 4.46688 6.6732H10.8728C11.149 6.6732 11.3728 6.44932 11.3728 6.17318C11.3728 5.89703 11.149 5.67318 10.8728 5.67318H4.46688ZM3.96688 9.1732C3.96688 8.89707 4.19073 8.6732 4.46688 8.6732H7.18647C7.46261 8.6732 7.68647 8.89707 7.68647 9.1732C7.68647 9.44933 7.46261 9.6732 7.18647 9.6732H4.46688C4.19073 9.6732 3.96688 9.44933 3.96688 9.1732ZM4.46688 11.6732C4.19073 11.6732 3.96688 11.8971 3.96688 12.1732C3.96688 12.4493 4.19073 12.6732 4.46688 12.6732H7.18644C7.46259 12.6732 7.68644 12.4493 7.68644 12.1732C7.68644 11.8971 7.46259 11.6732 7.18644 11.6732H4.46688ZM17.319 11.4277C17.321 12.4405 16.9772 13.4235 16.3445 14.2143C15.7429 14.9664 14.9143 15.5017 13.9844 15.7419C13.8896 15.7664 13.7901 15.7664 13.6953 15.7419C12.7654 15.5017 11.9368 14.9664 11.3351 14.2143C10.7025 13.4235 10.3587 12.4405 10.3607 11.4277V9.68813C10.3607 9.45747 10.4523 9.2362 10.6155 9.07313C10.7785 8.91 10.9998 8.81833 11.2305 8.81833H16.4492C16.6799 8.81833 16.9011 8.91 17.0643 9.07313C17.2274 9.2362 17.319 9.45747 17.319 9.68813V11.4277ZM15.9356 10.1733C16.1564 10.3391 16.201 10.6525 16.0352 10.8733L14.1129 13.4333C13.9472 13.654 13.6341 13.6987 13.4133 13.5333L12.1333 12.5745C11.9123 12.4089 11.8673 12.0955 12.0329 11.8745C12.1985 11.6535 12.5118 11.6085 12.7328 11.7741L13.6131 12.4335L15.2355 10.2729C15.4014 10.0521 15.7148 10.0075 15.9356 10.1733Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})